/* Bandeau de réassurance : sur téléphone, carrousel horizontal en boucle,
   un badge à la fois. Au-dessus de 749 px le script ne fait rien. */
(() => {
  const racine = document.querySelector('[data-lum-reassurance]');
  if (!racine) return;
  const liste = racine.querySelector('.lum-reassurance__liste');
  const origines = Array.from(liste.children);
  const n = origines.length;
  if (n < 2) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  let actif = false;
  let clones = [];
  let points = null;
  let minuterie = 0;
  let pauseJusqua = 0;
  let attente = 0;
  let observeur = null;
  let visible = true;

  const largeur = () => liste.clientWidth;
  const rang = () => Math.round(liste.scrollLeft / (largeur() || 1));
  const aller = (i, doux) => liste.scrollTo({ left: i * largeur(), behavior: doux ? 'smooth' : 'instant' });

  const sauter = (i) => {
    liste.style.scrollSnapType = 'none';
    liste.scrollLeft = i * largeur();
    requestAnimationFrame(() => { liste.style.scrollSnapType = ''; });
  };

  const majPoints = () => {
    if (!points) return;
    const reel = (rang() - 1 + n) % n;
    Array.from(points.children).forEach((p, k) => p.classList.toggle('is-actif', k === reel));
  };

  const poser = () => {
    const i = rang();
    if (i <= 0) sauter(n);
    else if (i >= n + 1) sauter(1);
    majPoints();
  };

  const surDefilement = () => {
    clearTimeout(attente);
    attente = setTimeout(poser, 120);
  };

  const pause = () => { pauseJusqua = Date.now() + 8000; };

  const suivant = () => {
    if (document.hidden || !visible || Date.now() < pauseJusqua) return;
    aller(rang() + 1, true);
  };

  const activer = () => {
    if (actif) return;
    actif = true;
    const debut = origines[n - 1].cloneNode(true);
    const fin = origines[0].cloneNode(true);
    [debut, fin].forEach((c) => {
      c.classList.add('lum-reassurance__item--clone');
      c.setAttribute('aria-hidden', 'true');
      c.removeAttribute('data-shopify-editor-block');
    });
    liste.insertBefore(debut, liste.firstChild);
    liste.appendChild(fin);
    clones = [debut, fin];
    liste.setAttribute('role', 'region');
    liste.setAttribute('aria-roledescription', 'carrousel');
    liste.setAttribute('aria-label', 'Nos engagements');

    points = document.createElement('div');
    points.className = 'lum-reassurance__points';
    points.setAttribute('aria-hidden', 'true');
    for (let k = 0; k < n; k++) points.appendChild(document.createElement('span'));
    racine.appendChild(points);

    sauter(1);
    majPoints();
    liste.addEventListener('scroll', surDefilement, { passive: true });
    liste.addEventListener('pointerdown', pause, { passive: true });
    liste.addEventListener('touchstart', pause, { passive: true });
    liste.addEventListener('focusin', pause);
    if (!reduit.matches) minuterie = setInterval(suivant, 5000);
    if ('IntersectionObserver' in window) {
      observeur = new IntersectionObserver((e) => { visible = e[0].isIntersecting; });
      observeur.observe(racine);
    }
  };

  const desactiver = () => {
    if (!actif) return;
    actif = false;
    clearInterval(minuterie);
    clearTimeout(attente);
    if (observeur) observeur.disconnect();
    liste.removeEventListener('scroll', surDefilement);
    liste.removeEventListener('pointerdown', pause);
    liste.removeEventListener('touchstart', pause);
    liste.removeEventListener('focusin', pause);
    clones.forEach((c) => c.remove());
    clones = [];
    if (points) points.remove();
    points = null;
    ['role', 'aria-roledescription', 'aria-label'].forEach((a) => liste.removeAttribute(a));
    liste.scrollLeft = 0;
  };

  const synchroniser = () => (mobile.matches ? activer() : desactiver());
  mobile.addEventListener('change', synchroniser);
  synchroniser();

  /* Rotation du téléphone : on garde le badge affiché. */
  let derniere = largeur();
  new ResizeObserver(() => {
    if (!actif) return;
    const w = largeur();
    if (w && w !== derniere) { const i = Math.max(1, Math.min(n, rang() || 1)); derniere = w; sauter(i); }
  }).observe(liste);
})();
